import { render } from "./Breeding.vue?vue&type=template&id=76b4df9d&scoped=true&ts=true"
import script from "./Breeding.vue?vue&type=script&lang=ts"
export * from "./Breeding.vue?vue&type=script&lang=ts"

import "./Breeding.vue?vue&type=style&index=0&id=76b4df9d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b4df9d"]])